import { render } from "./card-collapsible.vue?vue&type=template&id=ce03a978&ts=true"
import script from "./card-collapsible.vue?vue&type=script&lang=ts"
export * from "./card-collapsible.vue?vue&type=script&lang=ts"

import "./card-collapsible.vue?vue&type=style&index=0&id=ce03a978&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__